/* The scams that hit a new MC in its first 30 days — scraped from FMCSA the day it posts. */
export const NEW_AUTHORITY_SCAMS = [
  {
    id: "partner-conference-call",
    title: "\"Freight partnership\" — join my conference call",
    hook: "\"I came across your details on your platform and would like to partner on drayage / 40-ft containers at LAX, Houston, NJ… Dial-in number + Conference ID.\"",
    tells: ["No company name, MC, DOT, website, or signature", "Port/drayage work offered to a brand-new dry-van authority", "The whole email exists to get you on a phone line"],
    onCall: "Sign a \"carrier agreement\" (your authority gets used to double-broker), pay an onboarding/TWIC/insurance fee, or hand over bank or factoring info.",
    move: "Delete. No MC or DOT to check = no conversation.",
  },
  {
    id: "fake-fmcsa-audit",
    title: "\"FMCSA compliance audit\" or \"DOT fine\" call",
    hook: "\"This is the Department of Transportation. Your new entrant audit is scheduled — pay the $X processing fee today or your authority will be revoked.\"",
    tells: ["FMCSA never charges a fee for the New Entrant audit and never takes payment by phone", "Urgency + threat of revocation", "Caller ID spoofed to look like a DC number"],
    onCall: "Card payment for a \"compliance package,\" or your login to Motus/Portal \"to verify.\"",
    move: "Hang up. Real audit notices arrive by mail/Motus and never ask for money.",
  },
  {
    id: "lookalike-filing-sites",
    title: "UCR / BOC-3 / MCS-150 lookalike websites",
    hook: "Top-of-Google ads: \"UCR Registration 2026 — File Now.\" Same forms, 3–10× the real fee, plus a \"processing\" charge.",
    tells: ["URL is not fmcsa.dot.gov or ucr.gov", "Charges for the biennial MCS-150 update (it is free)", "Auto-renews your card next year"],
    onCall: "—",
    move: "UCR only at ucr.gov (~$46 for 0–2 trucks). MCS-150 only in Motus. BOC-3 via a real process agent ($25–50).",
  },
  {
    id: "load-board-access",
    title: "\"Load board access\" / fake DAT & Truckstop invoices",
    hook: "\"Your DAT account is suspended — pay here to restore access.\" Or a \"free load list\" that needs your login.",
    tells: ["Payment link is not on dat.com / truckstop.com", "You did not sign up under your own company yet", "Asks you to share or reuse someone else's login"],
    onCall: "—",
    move: "Only pay load boards through the account you opened under your own DOT. Never borrow a login — it violates their terms and gets your MC flagged.",
  },
  {
    id: "fuel-advance",
    title: "Fuel advance / fuel card \"pre-approval\"",
    hook: "\"Congratulations on your new authority — you're pre-approved for a $5,000 fuel advance / fleet card. Verify your bank to activate.\"",
    tells: ["You never applied", "Needs bank login or a voided check up front", "Pressure to \"activate before the offer expires\""],
    onCall: "—",
    move: "Fuel cards come from the card company after you apply. Nobody pre-approves a 3-day-old MC.",
  },
  {
    id: "double-broker-identity",
    title: "\"Send your packet to get set up\" — before you checked them",
    hook: "Friendly broker, real-sounding name, wants your W-9, COI, MC letter and a signed agreement today so they can \"add you to the network.\"",
    tells: ["You did not find them — they found you", "Not on BrokerCheck, or bond/insurance lapsed", "Email domain is Gmail/Outlook or a domain registered last month"],
    onCall: "Your packet becomes a stolen identity: loads booked under your MC, you never see the money, the shipper comes after you.",
    move: "Run them on BrokerCheck first. Only send the packet to brokers whose MC, bond and insurance you verified yourself.",
  },
];

export const REAL_BROKER_EMAIL = [
  "Company name, MC and DOT in the signature — and they match BrokerCheck",
  "A named person with a company-domain email (not Gmail) and a direct line you can call back",
  "They found you on a load board you posted to, or you called them — not a cold \"partnership\"",
  "They ask what lanes and equipment you run before they ask for your W-9",
  "Rate, pickup, delivery and payment terms in writing before you roll",
];
